import { z } from 'zod';

import { profileTaskClassificationValueTransportSchema } from '~/shared/data-contract/profile-task';

const opaqueIdSchema = z.string().trim().min(1);

/**
 * One task of a position, pinned to the work task version the position holds. A missing or unknown
 * classification reads as none, so a new backend value never drops the task.
 */
export const myPositionTaskSchema = z.object({
    classification: profileTaskClassificationValueTransportSchema.nullable().catch(null),
    id: opaqueIdSchema,
    order: z.number().int(),
    title: z.string(),
    version: z.number().int().positive(),
});

export type MyPositionTask = z.infer<typeof myPositionTaskSchema>;

/** A live position the signed-in person holds once their manager accepted its alignment, titled in the request language. */
export const myPositionSchema = z.object({
    architectureId: opaqueIdSchema,
    id: opaqueIdSchema,
    tasks: myPositionTaskSchema.array().default([]),
    title: z.string(),
    version: z.number().int(),
});

export type MyPosition = z.infer<typeof myPositionSchema>;

/** GET /users/me/positions: empty when the person holds no position with an accepted alignment. */
export const myPositionsResponseSchema = z.object({
    positions: myPositionSchema.array().default([]),
});

export type MyPositionsResponse = z.infer<typeof myPositionsResponseSchema>;
